module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/banner_app-1b4f60c2f4cee879401a607b41ca4269.png";